module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAD1BMVEUAAAB3d3d4eHh3d3d4eHh//olYAAAABHRSTlMAgL9ARyeO/QAAADRJREFUeNrt1CECwEAIxMAN9P9vbnvnAfxGj45mJV0p8XTxo6AqLkJVGGGEEUYsrtLF6HQvuPEDDbiQv+kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/空心正方形.png
// module id = Sl6V
// module chunks = 2